module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAOElEQVRIx2O8pKzDMBCAcdTiUYtpZvGj/NKBsfj///+jFo9aPMwsDt/SOjAWM/S6jVo8avHwshgAT5ohESWuYagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/hu.png
// module id = 838
// module chunks = 0